import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { favoriteOperations, favoriteSelectors } from 'ducks/favorites';

export function useIsFavorite({ entityType, entityId }) {
	const dispatch = useDispatch();

	const data = useMemo(() => ({ entityType, entityId }), [
		entityType,
		entityId
	]);

	const isFavorite = useSelector(
		favoriteSelectors.selectIsFavorite({ entityType, _id: entityId })
	);

	const toggleFavorite = useCallback(() => {
		if (isFavorite) {
			dispatch(favoriteOperations.removeFavorites(data));
		} else {
			dispatch(favoriteOperations.addFavorites(data));
		}
	}, [isFavorite, data]);

	return [isFavorite, toggleFavorite];
}
